<template>

  <div class="iris-messenger__template--confirm">
    <!-- GENERAL STYLING -->
    <transition-group name="pop-in">
      <div v-if="messages.length > 0" :key="'confirm-messages'">
        <div v-for="(message, key) in messages" :key="key"
             class="iris-message__toast flex flex-col  cursor-pointer noselect rounded shadow-lg"
             :class="{
            'text-white bg-success': message.type === 'success',
            'text-white bg-warning': message.type === 'warning',
            'text-white bg-danger': message.type === 'danger',
            'text-grey-600 bg-info': message.type === 'confirm',
            'text-grey-700 bg-white border border-grey-400': message.type === 'info' || message.type === '' || message.type ==='confirm',

          }"
        >
          <div class=" flex flex-row items-start justify-start">
            <div class="iris-message__icon p-4 text-3xl">
              <!-- ICON -->
              <i v-if="message.type === 'success'" class="fas fa-check-circle"></i>
              <i v-if="message.type === 'warning'" class="fas fa-exclamation-circle"></i>
              <i v-if="message.type === 'danger'" class="fas fa-exclamation-triangle"></i>
              <i v-if="message.type === 'info'" class="fas fa-info-circle"></i>
              <i v-if="message.type === 'confirm'" class="fas fa-question-circle"></i>
            </div>
            <!-- CENTER BODY -->
            <div class="iris-message__body flex flex-col p-4 w-full">
              <div class="iris-message__title font-bold  text-xl " v-if="hasTitle(message)">{{ message.title }}</div>
              <div class="iris-message__message leading-relaxed mt-3 text-lg" :class="{'text-xl py-1': !hasTitle(message)}" v-html="message.message"></div>
              <!-- CONFIRM BUTTONS -->
              <div class="iris-message__buttons-container flex flex-row justify-end mt-4 text-lg" >
                <button class=" rounded bg-grey-500 hover:bg-grey-600 text-white p-3" @click="$parent.close(message)">Abbrechen</button>
                <button class=" rounded bg-secondary_color hover:bg-secondary-800 text-white p-3 ml-4" @click="$parent.confirmAction(message)">OK</button>
              </div>
            </div>
            <button class="iris-message__close p-4 text-3xl hover:text-grey-300" @click="$parent.close(message)"><i class="fas fa-times"></i></button>
          </div>
          <div class="iris-message__countdown w-full h-1 bg-white opacity-50" :id="message.id" :style="`animation-duration: ${message.countdown}ms`"></div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "iris-messenger-template-confirm",
  props: {
    messages: { type: Array, required: false }
  },
  methods: {
    hasTitle(message) {
      return message.title.length > 0;
    },



  },



}
</script>

<style scoped>
.iris-messenger__template--confirm {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}

.iris-message__toast {
  max-width: 40vw;
  pointer-events: all;
}


.iris-message__countdown {
  animation-name: countdown;
  animation-delay: 200ms;
  animation-fill-mode: forwards;
  animation-iteration-count: initial;
  animation-direction: normal;
  animation-play-state: running;
  animation-timing-function: linear
}

@keyframes countdown {
  0% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}

/* Pop-in transition from center */
.pop-in-enter-active {
  transition: all 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.pop-in-leave-active {
  transition: all 0.2s ease-in;
}

.pop-in-enter-from {
  opacity: 0;
  transform: scale(0.6);
}

.pop-in-leave-to {
  opacity: 0;
  transform: scale(0.8);
}

.pop-in-enter-to, .pop-in-leave-from {
  opacity: 1;
  transform: scale(1);
}
</style>